/** The shared kit's strings, in the active language — see src/lib/i18n.js. */
import { pickLocale } from '../lib/i18n'
import * as ar from './strings.ar'
import * as en from './strings.en'

export const table = pickLocale(ar.table, en.table)
export const kit = pickLocale(ar.kit, en.kit)
export const excel = pickLocale(ar.excel, en.excel)
export const notificationStates = pickLocale(ar.notificationStates, en.notificationStates)
export const notifications = pickLocale(ar.notifications, en.notifications)
export const editor = pickLocale(ar.editor, en.editor)
export const theme = pickLocale(ar.theme, en.theme)
export const transport = pickLocale(ar.transport, en.transport)
export const feature = pickLocale(ar.feature, en.feature)
